/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bell'
export default icon
